import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { AdminSetariComponent } from './admin-setari.component';
import { ConfigurariComponent } from './configurari/configurari.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddConfigComponent } from './configurari/add-config/add-config.component';
import { StorageLocationsComponent } from './storage-locations/storage-locations.component';
import { AddStorageLocationsComponent } from './storage-locations/add-storage-locations/add-storage-locations.component';
import { EditStorageLocationsComponent } from './storage-locations/edit-storage-locations/edit-storage-locations.component';
import { CronComponent } from './cron/cron.component';
import { AddCronComponent } from './cron/add-cron/add-cron.component';
import { EditConfigComponent } from './configurari/edit-config/edit-config.component';
import { EditCronComponent } from './cron/edit-cron/edit-cron.component';
import { SignSettingsConfigurationComponent } from './sign-settings-configuration/sign-settings-configuration.component';
import { SigningLogsComponent } from './signing-logs/signing-logs.component';
import { AuditLogsComponent } from './audit-logs/audit-logs.component';
import { AuditArchivesComponent } from './audit-archives/audit-archives.component';
import { DataTablesModule } from 'angular-datatables';

@NgModule({
    declarations: [
        AdminSetariComponent,
        ConfigurariComponent,
        AddConfigComponent,
        StorageLocationsComponent,
        AddStorageLocationsComponent,
        EditStorageLocationsComponent,
        CronComponent,
        AddCronComponent,
        EditConfigComponent,
        EditCronComponent,
        SignSettingsConfigurationComponent,
        SigningLogsComponent,
        AuditLogsComponent,
        AuditArchivesComponent,
    ],
    exports: [AdminSetariComponent],
    imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, DataTablesModule],
})
export class AdminSetariModule { }
